import React, { FC, useEffect } from 'react';
import { useMeasure } from 'react-use';

import { useHeaderMeasure } from 'hooks/globals';
import { useConstConfigs } from 'modules/Core/hooks';
import { Notification } from 'modules/Notification';
import { ClientOnly } from 'modules/UI';

import HeaderActions from '../HeaderActions';
import HeaderLogo from '../HeaderLogo';
import { Container, Content, Header, LogoSpacer, NavLinks, NavSpacer } from './styles';

const HeaderDesktop: FC = () => {
  const { SHOW_CLIENT_ONLY_ROUTES } = useConstConfigs();

  const [measureRef, measure] = useMeasure();
  const [, setMeasure] = useHeaderMeasure();

  useEffect(() => {
    setMeasure(measure);
  }, [measure]);

  return (
    <Container
      ref={(e: Element | null): void => {
        e && measureRef(e);
      }}
    >
      <Header>
        <Content>
          <HeaderLogo />

          <LogoSpacer />

          <NavLinks />

          <NavSpacer />

          {SHOW_CLIENT_ONLY_ROUTES && (
            <ClientOnly>
              <HeaderActions />
            </ClientOnly>
          )}
        </Content>
      </Header>
      <Notification />
    </Container>
  );
};

export default HeaderDesktop;
